import { Link } from "@heroui/react";
import { SiMastodon } from "@icons-pack/react-simple-icons";

import { Button } from "../../core/Button";

export const MastodonButton = () => {
  return (
    <Button
      as={Link}
      size="sm"
      href="https://social.fediverse.events/@canvas"
      target="_blank"
      variant="ghost"
    >
      <SiMastodon size={18} />
      <p>Mastodon</p>
    </Button>
  );
};
